// import * as artistApi from '@/api/artist/artist.js';
import * as accountApi from '@motionelements/core/src/api/account.js';
import * as elementsApi from '@/api/artist/elements.js';
import * as collectionsApi from '@/api/artist/collections.js';
import programsApi from '@/api/artist/programs.js';
import { getPhotoIdReview } from '@/api/reviews.js';
// import DOMPurify from 'dompurify';

const gcpProgram = {
  subprograms: [],
};

const state = {
  account: null,
  elements: [],
  collections: [],
  // vvapPrice: 0,
  program: {
    gcp: gcpProgram,
  },
  programs: [],
  photoIdReview: null,
  elementCounts: {
    all: null,
    published: 0,
    draft: 0,
  },
  countsLoading: false,
  photoIdLoading: false,
  //
  verificationItemsLoaded: [],
};

const getters = {
  account: ({ account }) => account,
  elements: ({ elements }) => elements,
  collections: ({ collections }) => collections,
  hasCollections: state => (state.collections.length > 0 ? _.get(state.collections[0], 'count') > 0 : false),
  // gcpProgram: ({ programs }) => programs.filter(x => x.type === 'gcp'),
  gcpPrograms: ({ programs }) => programs.filter(x => x.type === 'gcp'),
  addOns: ({ programs }) => programs.filter(x => ['convert', 'ftp'].includes(x.type)),
  getProgramsByType: (state) => (type) => state.programs.filter(x => x.type === type),
  getProgramByCode: (state) => (code) => state.programs.find(x => x.code === code),
  //
  isGcpSubscriptionActive(state, getters) {
    const gcpSubscription = getters.getProgramByCode('gcp_subscription');
    return gcpSubscription ? gcpSubscription.status === 'active' : false;
  },
  activeGcpPrograms(state, getters) {
    return getters.gcpPrograms.filter(({ status }) => status === 'active');
  },
};

const mutations = {
  setPrograms(state, data) {
    state.programs = data;
  },
  setProgram(state, program) {
    const index = state.programs.findIndex(x => x.id === program.id);
    if (index > -1) {
      state.programs.splice(index, 1, program);
    }
  },
  setGcpProgram(state, data) {
    state.program.gcp = data;
  },
  setPhotoIdReview(state, data) {
    state.photoIdReview = data;
  },
  setArtistDetails(state, data) {
    state.account = data;
  },
  setArtistElementsStats(state, data) {
    state.elements = data;
  },
  setArtistCollectionsStats(state, data) {
    state.collections = data;
  },
  // ======= DOWN CONVERT ======= //
  // setDownConvertLoading({ program: { downConvert } }, status) {
  //   downConvert.loading = status;
  // },
  // setDownConvert({ program: { downConvert } }, subprograms) {
  //   downConvert.subprograms = subprograms;
  // },
  // updateDownConvertSub({ program: { downConvert } }, { id, path, value }) {
  //   const subProgram = downConvert.subprograms.find(sub => sub.id === id);
  //   _.set(subProgram, path, value);
  // },
  // ======= END DOWN CONVERT ======= //
  setElementCounts(state, { status, value }) {
    state.elementCounts[status] = value;
  },
  setCountsLoading(state, loading) {
    state.countsLoading = loading;
  },
  setPhotoIdLoading(state, loading) {
    state.photoIdLoading = loading;
  },
  //
  updateVerificationItemsLoaded(state, payload) {
    state.verificationItemsLoaded.push(payload);
  },
  resetVerificationItemsLoaded(state) {
    state.verificationItemsLoaded = [];
  },
};

const actions = {
  getArtistDetails({ commit }) {
    // fields[member]=artist_details
    accountApi.getAccount({
      'fields[member]': 'artist_details',
    }).then((response) => {
      commit('setArtistDetails', response.data.data);
    });
  },
  // params is optional
  listPrograms({ commit }, { params } = {}) {
    return programsApi.listPrograms(params).then((response) => {
      commit('setPrograms', response.data.data);
      return response;
    });
  },
  getLatestPhotoIdReview({ commit }, { params } = {}) {
    commit('setPhotoIdLoading', true);
    return getPhotoIdReview(params)
      .then((response) => {
        // response.data.data.result = 'rejected';
        // response.data.data.legacy = false;
        commit('setPhotoIdReview', response.data.data);
        return response;
      })
      .catch((error) => {
        const statusCode = _.get(error, 'response.status');
        if (statusCode === 404) {
          commit('setPhotoIdReview', {});
        }
      })
      .finally(() => {
        commit('setPhotoIdLoading', false);
      });
  },
  getGcpProgram({ commit }) {
    return programsApi.getProgram('gcp').then((response) => {
      commit('setGcpProgram', response.data.data);
      return response;
    });
  },
  getArtistElementsStats({ commit }) {
    // return artistApi.getArtistElementsStats()
    commit('setCountsLoading', true);
    return elementsApi.getElementsStats()
      .then((response) => {
        const all = response.data.data.find(x => x.mediaType === 'all');
        commit('setArtistElementsStats', response.data.data);
        commit('setElementCounts', {
          status: 'all',
          value: all ? _.get(all, 'count', 0) : 0,
        });
        return response;
      })
      .finally(() => {
        commit('setCountsLoading', false);
      });
  },
  getArtistCollectionsStats({ commit }) {
    // artistApi.getArtistCollectionsStats().then((response) => {
    return collectionsApi.getCollectionsStats().then((response) => {
      commit('setArtistCollectionsStats', response.data.data);
      return response;
    });
  },
  optInGcpProgram(state, { subProgramId }) {
    return programsApi.optIn({ subProgramId });
  },
  optOutGcpProgram({ commit }, subProgramId) {
    return programsApi.optOut(subProgramId)
      .then((response) => {
        commit('setProgram', response.data.data);
        return response;
      });
  },
  updateGcpProgram(state, { subProgramId, data }) {
    return programsApi.updateSubProgram({ subProgramId, data });
  },

  // ======= PROGRAMS ======= //
  optInSubProgram(state, { subProgramId, data }) {
    return programsApi.optIn({ subProgramId, data });
  },
  optOutSubProgram(state, subProgramId) {
    return programsApi.optOut(subProgramId);
  },
  updateSubProgram(state, { subProgramId, data }) {
    return programsApi.updateSubProgram({ subProgramId, data });
  },
  // ======= END PROGRAMS ======= //

  // ======= DOWN CONVERT ======= //
  // getDownConvert({ commit }) {
  //   commit('setDownConvertLoading', true);
  //   return programsApi.getProgram('convert')
  //     .then((response) => {
  //       commit('setDownConvert', response.data.data.subprograms);
  //       commit('setDownConvertLoading', false);
  //       return response;
  //     });
  // },
  // optInDownConvert({ commit, dispatch }, { subProgramId, data }) {
  //   // commit('setDownConvertLoading', true);
  //   return dispatch('optInSubProgram', { subProgramId, data });
  // },
  // optOutDownConvert({ dispatch }, subProgramId) {
  //   return dispatch('optOutSubProgram', subProgramId);
  // },
  // ======= END DOWN CONVERT ======= //
  //
  getElementCounts({ commit }, status) {
    return elementsApi.getElementsStats({ status })
      .then((response) => {
        const all = response.data.data.find(x => x.mediaType === 'all');
        commit('setElementCounts', {
          status,
          value: all ? _.get(all, 'count', 0) : 0,
        });
        return response;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
